<template>
  <div class="col-12 staff-availablility my-2">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center">
          <div class="position-relative mr-2">
            <div
                class="mr-2 status-image"
                :ref="`staff-toggler-${staff.id}`"
                @click="showStaffProfile = !showStaffProfile"
            >
              <user-avatar :avatarURL="statusImage"></user-avatar>
              <svg height="16" width="16" style="position: absolute;right: 8px;top: 0;border-radius: 50%;">
                <circle
                    cx="8"
                    cy="8"
                    r="8"
                    stroke="white" stroke-width="3"
                    :fill="availabilityColor(staff.availability)"
                />
              </svg>
            </div>
            <transition name="fade">
              <div
                  :ref="`dropdown-staff-${staff.id}`"
                  v-closable="{
                            exclude: [`dropdown-staff-${staff.id}`, `staff-toggler-${staff.id}`],
                            handler: 'toggleCloseAllDropdown'
                         }"
                  v-if="showStaffProfile"
                  class="dropdown-menu justify-content-center flex-column align-items-center mobile d-flex"
              >
                <div class="container">
                  <div class="row mb-2">
                    <div class="col d-flex justify-content-center">
                      <user-avatar :avatarURL="staff.avatar_src" size="80"></user-avatar>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col text-center">
                      {{ staffName }}
                    </div>
                  </div>
                  <div class="row my-1">
                    <div class="col-2"><i class="fas fa-suitcase"></i></div>
                    <div class="col-10 profile-detail">{{ staff.designation }}</div>
                  </div>
                  <div class="row my-1">
                    <div class="col-2"><i class="fas fa-envelope"></i></div>
                    <div class="col-10 profile-detail">
                      <a :href="`mailto:${staff.email}`">{{ staff.email }}</a>
                    </div>
                  </div>
                  <div class="row my-1">
                    <div class="col-2"><i class="fas fa-phone-alt"></i></div>
                    <div class="col-10 profile-detail">
                      <a :href="`tel:+${staff.phone_number}`" v-if="staff.phone_number">+{{
                          staff.country_calling_code
                        }}{{ staff.phone_number }}</a>
                    </div>
                  </div>
                  <div class="row mt-3 mb-2">
                    <div class="col">
                      <a class="btn wfh-btn-primary-outline w-100" :href="`/users/directory?uid=${staff.hashedId}`">
                        View Profile
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div>
            <div class="name overflow-hidden text-nowrap" style="max-width: 170px;text-overflow: ellipsis;">
              {{ staffName }}
            </div>
            <div class="muted-text">
              {{ staff.designation }}
            </div>
          </div>
          <div class="flex-fill text-right"  v-if="checkInEnabled">
            <div class="muted-text">
              {{ availabilityText(staff.availability) }}
            </div>
            <div class="muted-text" style="font-size: 10px;">
              {{ formattedFirstCheckIn }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

const statusText = ["check_in", "check_out", "break", "away", "continue","on_leave"];

export default {
  props: {
    staff: {
      required: true,
      type: Object
    },
    timezone: {
      default: null,
      type: String
    }
  },

  data() {
    return {
      showStaffProfile: false
    };
  },

  computed: {
    firstCheckIn() {
      return this.staff.firstCheckIn;
    },

    formattedFirstCheckIn() {
      if (!this.firstCheckIn) return;

      if (this.staff.availability == "break") {
        for (let i = 0; i < this.firstCheckIn.length; i++) {
          if (
            this.firstCheckIn[i]["status"] == "break" ||
            statusText[this.firstCheckIn[i]["status"] - 1] == "break"
          ) {
            return this.timezone
              ? moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .tz(this.timezone)
                  .format("h:mm A")
              : moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .local()
                  .format("h:mm A");
          }
        }
      } else if (this.staff.availability == "away") {
        for (let i = 0; i < this.firstCheckIn.length; i++) {
          if (
            this.firstCheckIn[i]["status"] == "away" ||
            statusText[this.firstCheckIn[i]["status"] - 1] == "away"
          ) {
            return this.timezone
              ? moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .tz(this.timezone)
                  .format("h:mm A")
              : moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .local()
                  .format("h:mm A");
          }
        }
      } else if (this.staff.availability == "check_out") {
        for (let i = 0; i < this.firstCheckIn.length; i++) {
          if (
            this.firstCheckIn[i]["status"] == "check_out" ||
            statusText[this.firstCheckIn[i]["status"] - 1] == "check_out"
          ) {
            return this.timezone
              ? moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .tz(this.timezone)
                  .format("h:mm A")
              : moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .local()
                  .format("h:mm A");
          }
        }
      } else if (
        this.staff.availability == "check_in" ||
        this.staff.availability == "continue"
      ) {
        for (let i = 0; i < this.firstCheckIn.length; i++) {
          if (
            this.firstCheckIn[i]["status"] == "check_in" ||
            statusText[this.firstCheckIn[i]["status"] - 1] == "check_in"
          ) {
            return this.timezone
              ? moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .tz(this.timezone)
                  .format("h:mm A")
              : moment
                  .utc(this.firstCheckIn[i]["created_at"])
                  .local()
                  .format("h:mm A");
          }
        }
      } else {
        return;
      }
    },

    statusImage() {
      return this.staff.status_image
        ? this.staff.status_image
        : this.staffAvatar
        ? this.staffAvatar
        : "/images/Default.png";
    },

    staffAvatar() {
      return this.staff.avatar_src ? this.staff.avatar_src : "/images/Default.png";
    },

    staffName() {
      return this.staff?.display_name
        ? this.staff.display_name
        : this.staff.name ?? this.staff.email;
    },

    checkInEnabled(){
      return hasPermission('check_ins');
    }
  },

  methods: {
    availabilityText(availability) {
      return (
        {
          check_in: "Online",
          continue: "Online",
          check_out: "Checked out",
          break: "On break",
          away: "Away",
          inactive: "Invited",
          on_leave: "On Leave",
          holiday: "On holiday",
        }[availability] || ""
      );
    },

    availabilityColor(availability) {
      return (
        {
          check_in: "#82df6b",
          continue: "#82df6b",
          check_out: "#e0e0e0",
          break: "#e0e0e0",
          away: "#ffe171",
          on_leave: "#e0e0e0",
          holiday: "#e0e0e0",
        }[availability] || "#e0e0e0"
      );
    },

    toggleCloseAllDropdown() {
      this.showStaffProfile = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.staff-availablility {
  .first-checked-in {
    opacity: 0.5;
  }

  &:hover {
    .first-checked-in {
      opacity: 1;
    }
  }
}

.name {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.muted-text {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.position {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  letter-spacing: 0;
  line-height: 22px;
}

.dropdown-menu {
  left: 60px !important;
  top: 0;
  width: 210px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999999999;

  @media (max-width: 767px) {
    &.mobile {
      left: auto;
      top: auto;
      bottom: 0;
    }
  }

  .profile-detail {
    color: #808fa4;
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    font-weight: 100;
    letter-spacing: 0;
    line-height: 22px;
  }
}

.status-image {
  cursor: pointer !important;
}
</style>
